import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import $ from "jquery";
const CaisseBankEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
 
  const [backendErrors, setBackendErrors] = useState([]);
  // const [paymentMethods, setPaymentMethods] = useState([]);  
  const [primaryCurrency, SetPrimaryCurrency] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
    const [permission, setPermission] = useState({});
 

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
 const operationtypes = ([
    { value: 'Vente déchets', label: "Vente déchets" },
    { value: 'MAD', label: "MAD" },
    { value: 'Avance', label: "Avance" },
    { value: 'Alimentation Caisse', label: "Alimentation Caisse" },
    { value: 'Divers', label: "Divers" }
  ]);
  const typeexpenses = ([
    { value: 'Vignette', label: "Vignette" },
    { value: 'Reparation Auto', label: "Reparation Auto" },
    { value: 'Assurance Auto', label: "Assurance Auto" },
    { value: 'Gasoil', label: "Gasoil" },
    { value: 'Frais de deplacement - Reunion', label: "Frais de deplacement - Reunion" },
    { value: 'Transport MP', label: "Transport MP" },
    { value: 'Transport matiere divers', label: "Transport matiere divers" },
    { value: 'Salaire(s) Espece', label: "Salaire(s) Espece" },
    { value: 'Frais Telephone  et Internet', label: "Frais Telephone  et Internet" },
    { value: 'Primes de fin de saison', label: "Primes de fin de saison" },
    { value: 'Reparation PC et accessoires', label: "Reparation PC et accessoires" },
    { value: 'Frais divers', label: "Frais divers" },
    { value: 'Don', label: "Don" },
    { value: 'Achat Matiere premiere', label: "Achat Matiere premiere" },
    { value: 'Alimentation Caisse', label: "Alimentation Caisse" },
    ]);
  const [selectedOperation, setSelectedOperation] = useState('');
  const paymenttypes = ([
    { value: 'Virement', label: "Virement" },
    { value: 'Cheque', label: "Cheque" },
    { value: 'Lettre De Change', label: "Lettre De Change" },
  ]);  
  const chequelist = ([
    { value: 'Encaisse', label: "Encaisse" },
    { value: 'Non Encaisse', label: "Non Encaisse" }
  ]);  
 
  const customfunction = (value) => {
    setSelectedOperation(value); // Update the selected operation state
  };
  const [checklistshow, setChecklistshow] = useState('');


  const formik = useFormik({
    initialValues: {
      id: value.id,
      operation: value.operation,
      date: value.date,
      amount: value.amount,
      payed_to: value.payed_to,
      expense_type: value.expense_type,
      currency:value.currency,
      note:value.note,
      operation_type:value.operation_type,
      paid_by:value.paid_by,
      payment_type:value.payment_type,
      cheque:value.cheque
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values , { setSubmitting }) => {
      axios
        .post("/caisse-bank/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
         
          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Update Caisse Bank");
           if (response.data.code === 200) {
            
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/caisse-bank";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(449)); 
console.log(permission);

  
    axios
    .get(`/helpers/currencies`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let currencies = response.data.data.currencies;
        let currencieslist = currencies.map((customer, index) => ({
          label: customer.title,
          symbol: customer.symbol,
          value: customer.id,
          key: `types-${index}`,
        }));
        SetPrimaryCurrency(currencieslist);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios
      .get(`/caisse-bank/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         setValue(response.data.data.caisse);
         setSelectedOperation(response.data.data.caisse.operation);
         setChecklistshow(response.data.data.caisse.payment_type);
         axios.get(`/helper/currency-symbol-by-currency-id/${response.data.data.caisse.currency}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
          // console.log(response.data.data);
            setCurrencySymbol(response.data.data.currency_symbol)
          
          }
        })
        .catch((error) => {
          console.log(error);
        });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);


  useEffect(() => {
    

}, []);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const selectPaymentType = (event) => {
    const peymenttype = event.value;
    if(peymenttype == 'Cheque'){
      setChecklistshow(peymenttype);
    }else{
      setChecklistshow('');
    }
  
  };
  const customFuction = (event) =>{
    console.log(event)
    // var index = event.target.selectedIndex;
    // var optionElement = event.target.childNodes[index];
    // var key_sybmol =  optionElement.getAttribute('key_sybmol');
    // console.log(key_sybmol);
    setCurrencySymbol(event.symbol)
   
  }

  const operationArr = ([
    { value: 'IN', label: "IN" },
    { value: 'OUT', label: "OUT" },
  ]);
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Caisse Bank</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/caisse-bank">Caisse Bank</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Caisse Bank Info</h4>
                    {permission && permission.update === 1 && (
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                        
                      
                      <div className="row">


                      <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Operation</label>
                                {operationArr.length > 0 && (
                                      <Select
                                      className="w-100"
                                      value={operationArr.find(option => option.value == formik.values.operation) || null} // Ensure correct format
                                      name="operation"
                                      //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                      onChange={(selectedOption) => {
                                        handleSelectChange("operation", selectedOption);
                                        customfunction(selectedOption.value);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={operationArr}
                                      placeholder="Select"

                             />
                                )}
                              
                                <small>
                                  {backendErrors.operation  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.operation}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            {selectedOperation === 'OUT'  && (
                        <div className="col-md-6">
                        <div className="form-group">
                            <label>Payed To</label>
                           
                            <div className="input-group">
                                <input type="text" 
                                name="payed_to"
                                value={formik.values.payed_to}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                  onBlur={formik.handleBlur}
                                className="form-control" placeholder="Payed To"  />
                                
                            </div>
                            <small>
                              {backendErrors.payed_to && (
                                  <span className="form-error mt-1">
                                    {backendErrors.payed_to}
                                  </span>
                                )}
                            </small>
                          </div>
                     </div>
                     
                       )}
                       {selectedOperation === 'OUT'  && (
                       <div className="col-md-6">
                       <div className="form-group">
                           <label>Select Type of Expense</label>
                           <Select
                              className="w-100"
                              value={typeexpenses.find(option => option.value == formik.values.expense_type) || null} // Ensure correct format
                              name="expense_type"
                              //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                              onChange={(selectedOption) => {
                                handleSelectChange("expense_type", selectedOption);
                                //customFuction(selectedOption);
                              }}
                              onBlur={formik.handleBlur}
                              options={typeexpenses}
                              placeholder="Select"  

                            //  className= "w-100"
                            //  data={typeexpenses}
                            //  value={formik.values.expense_type}
                            //  name="expense_type"
                            //  onChange={(e) => {
                            //    formik.handleChange(e);
                            //    customHandleInput(e);
                              
                            //  }}
                            //  onBlur={formik.handleBlur}
                            //  options={{
                            //    placeholder: "Select ",
                            //  }}
                           />
                           <small>
                             {backendErrors.expense_type  && (
                               <span className="form-error mt-1">
                                 {backendErrors.expense_type}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                     )}

                      {selectedOperation === 'IN' && (
                        <div className="col-md-6">
                        <div className="form-group">
                            <label>Paid By</label>
                           
                            <div className="input-group">
                                <input type="text" 
                                name="paid_by"
                                value={formik.values.paid_by}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                  onBlur={formik.handleBlur}
                                className="form-control" placeholder="Paid By"  />
                                
                            </div>
                            <small>
                              {backendErrors.paid_by && (
                                  <span className="form-error mt-1">
                                    {backendErrors.paid_by}
                                  </span>
                                )}
                            </small>
                          </div>
                     </div>
                     
                       )}
  {selectedOperation === 'IN' && (
                        <div className="col-md-6">
                        <div className="form-group">
                            <label>Operation Type</label>
                           
                            <div className="input-group">
                            <Select
                              className="w-100"
                              value={operationtypes.find(option => option.value == formik.values.operation_type) || null} // Ensure correct format
                              name="operation_type"
                              //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                              onChange={(selectedOption) => {
                                handleSelectChange("operation_type", selectedOption);
                                //customFuction(selectedOption);
                              }}
                              onBlur={formik.handleBlur}
                              options={operationtypes}
                              placeholder="Select"  

                             
                           />
                                
                            </div>
                            <small>
                              {backendErrors.operation_type && (
                                  <span className="form-error mt-1">
                                    {backendErrors.operation_type}
                                  </span>
                                )}
                            </small>
                          </div>
                     </div>
                     
                       )}


                          {selectedOperation === 'IN' && (
                       <div className="col-md-6">
                       <div className="form-group">
                           <label>Select Payment Type</label>
                           <Select
                             className="w-100"
                             value={paymenttypes.find(option => option.value == formik.values.payment_type) || null} // Ensure correct format
                             name="payment_type"
                             //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                             onChange={(selectedOption) => {
                               handleSelectChange("payment_type", selectedOption);
                               selectPaymentType(selectedOption);
                             }}
                             onBlur={formik.handleBlur}
                             options={paymenttypes}
                             placeholder="Select"  

                             
                           />
                           <small>
                             {backendErrors.payment_type  && (
                               <span className="form-error mt-1">
                                 {backendErrors.payment_type}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                     )}
                        {checklistshow === 'Cheque' && (
                       <div className="col-md-6">
                       <div className="form-group">
                           <label>Select Cheque Status</label>
                           <Select
                             className="w-100"
                             value={chequelist.find(option => option.value == formik.values.cheque) || null} // Ensure correct format
                             name="cheque"
                             //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                             onChange={(selectedOption) => {
                               handleSelectChange("cheque", selectedOption);
                               //selectPaymentType(selectedOption);
                             }}
                             onBlur={formik.handleBlur}
                             options={chequelist}
                             placeholder="Select"  

                           />
                           <small>
                             {backendErrors.cheque  && (
                               <span className="form-error mt-1">
                                 {backendErrors.cheque}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                     )}


                      <div className="col-md-6">
                            <div className="form-group status2">
                              <label>Select Currency</label>
                           
                              <Select
                                          className="w-100"
                                          value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                          name="currency"
                                          //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                          onChange={(selectedOption) => {
                                            handleSelectChange("currency", selectedOption);
                                            customFuction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={primaryCurrency}
                                          placeholder="Select"   
                                          />
                              <small>
                                {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                              </small>
                              </div>
                             
                            </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label>Amount</label>
                              <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount"
                                  value={formik.values.amount}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Amount" aria-label="Amount" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                              </div>
                              <small>
                                {backendErrors.amount && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amount}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                       <div className="col-md-6">
                          <div className="form-group">
                              <label>Date</label>
                              <input
                                type="date"
                                name="date"
                                value={formik.values.date}
                                className={
                                  backendErrors.date
                                    ? "form-input form-control input-error datetimepicker"
                                    : "form-input form-control datetimepicker"
                                }
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                 onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                            <div className="col-md-12">
                              <label>Note</label>
                                  <textarea 
                                  name="note"
                                  value={formik.values.note}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Note" >
                                  </textarea>
                              <small>
                                {backendErrors.note && (
                                    <span className="form-error mt-1">
                                      {backendErrors.note}
                                    </span>
                                  )}
                              </small>
                         </div>
                        </div>
                       
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                          Update Caisse Bank
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CaisseBankEdit;
